<template>
  <div
    :class="`as-wrapper-player as-wrapper-player__item ${modeTeam} ${modifyClass}`"
  >
    <div class="as-item-img as-group as-show-full" v-if="sub_ids.length">
      <div class="as-group-imgs">
        <img
          v-for="(sub, key) in sub_ids"
          :key="key"
          class="as-img-player"
          :class="`team-logo-${key}`"
          :src="getImgUrlBySport('team', sub)"
        />
      </div>
      <div class="as-item-badge">
        <div class="as-item-badge-num">{{ scores }}</div>
      </div>
    </div>
    <div class="as-item-img" v-else>
      <div class="as-d-inline-flex">
        <img v-if="logo" class="as-img-player" :src="logo" />
        <img
          v-else
          class="as-img-player"
          :src="getImgUrlBySport('team', team.id)"
        />
      </div>
      <div class="as-item-badge">
        <div class="as-item-badge-num">{{ scores }}</div>
        <div class="as-item-badge-flag" v-if="country">
          <img class="as-img-badge-flag" :src="country" />
        </div>
      </div>
    </div>
    <div class="as-item-info as-show-full" v-if="sub_ids.length">
      <span :key="key" v-for="(_name, key) in names">{{ _name }}</span>
    </div>
    <div class="as-item-info" v-else>
      <span>{{ team.name }}</span>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import type { IMatch, IMatchTennis } from "~src/interfaces/tennis";

interface IProps {
  match: IMatch | IMatchTennis;
  team: any;
  country: string;
  scores: string | number | any;
  mode?: string;
  modeTeam?: string;
  session?: string;
  modifyClass?: string;
  logo?: string;
}
const props = withDefaults(defineProps<IProps>(), {
  scores: "20",
  mode: "tennis",
  modeTeam: "",
  session: "",
  modifyClass: "",
  logo: "",
});

const sub_ids = computed(() => {
  return props.team?.sub_ids ?? "";
});

const names = computed(() => {
  return props.team?.name.split("/");
});
</script>

<script lang="ts">
export default {};
</script>
